const dynasties = {
	164790: 'tang',
	158363: 'song',
	158364: 'yuan',
	158365: 'ming',
	2127206: 'tang',
	2127207: 'song',
	2127208: 'yuan',
	2127209: 'ming',
}

export function ChinaDynastyBox({ allUpgrades, civilization }) {
	let upgradesRequired = []
	if (civilization === 'Chinese') {
		upgradesRequired = [164790, 158363, 158364, 158365]
	} else if (civilization === 'ZhuXi') {
		upgradesRequired = [2127206, 2127207, 2127208, 2127209]
	} else {
		return <></>
	}

	let dynastyUpgrades = Object.values(allUpgrades || [])?.filter((upgrade) => upgradesRequired?.includes(parseInt(upgrade)))
	let currentDynasty = dynastyUpgrades?.[dynastyUpgrades.length - 1] || upgradesRequired[0]
	let icon = `/liveGameIcons/unique/${dynasties[currentDynasty]}.png`

	return (
		<div
			className="w-[84px] h-[40px] justify-center border-solid border flex flex-row items-center"
			style={{
				backgroundImage: `url(/liveGameIcons/BACKGROUND.png)`,
				borderColor: 'var(--main-color)',
			}}>
			<img className="w-[34px] h-[34px]" src={icon} alt="" />
			<div className="flex flex-row items-center max-w-[47px] justify-end mr-[2px]">
				<h1 className="text-white text-lg capitalize">{dynasties[currentDynasty]} </h1>
			</div>
		</div>
	)
}
